import { HEALTHY_SUBSCRIPTION_STATUSES } from '@snootsvet/shared/portal'

import { useGetMe } from '@/customer/hooks/use-get-me'
import { useListInvoices } from '@/customer/hooks/use-list-invoices'
import { usePetsWithSubscriptions } from '@/customer/hooks/use-pets-with-subscriptions'
import { hasOnboardedPet, type MembershipIssue } from '@/customer/lib/membership'
import { routes } from '@/customer/routes'

export function useMembershipIssues(): { issues: MembershipIssue[]; isPending: boolean } {
  const me = useGetMe()
  const { pets, isPending: petsPending } = usePetsWithSubscriptions()
  const { invoices, isPending: invoicesPending } = useListInvoices({ status: 'overdue' })

  if (
    me.isPending ||
    !me.data ||
    petsPending ||
    invoicesPending ||
    pets.some((pet) => pet.subscriptionQuery.isPending)
  ) {
    return { issues: [], isPending: true }
  }

  const issues: MembershipIssue[] = []

  if (invoices.length > 0) {
    issues.push({
      type: 'overdue_invoice',
      title: 'You have overdue invoices',
      action: { href: routes.account.billing.index, label: 'View invoices' },
    })
  }

  const hasCompletedPetOnboarding = hasOnboardedPet(me.data.patients)
  const hasBookablePet = pets.some((pet) => {
    const status = pet.subscriptionQuery.data?.subscription?.status
    return status && HEALTHY_SUBSCRIPTION_STATUSES.has(status)
  })

  if (hasCompletedPetOnboarding && !hasBookablePet) {
    issues.push({
      type: 'no_bookable_pet',
      title: 'None of your pets currently have an active membership',
      action: { href: routes.account.pets.index, label: 'Activate membership' },
    })
  }

  return { issues, isPending: false }
}
